import { Component, Input } from '@angular/core';

@Component({
    selector: 'add-field-link',
    templateUrl: './add-field-link.component.html',
    styleUrls: ['./add-field-link.component.scss'],
    standalone: false
})
export class AddFieldLinkComponent {

  @Input() public inputMessage: string;
}
